module.exports = __webpack_public_path__ + "static/media/objective-blue.4bc40efe.svg";